/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import FilePreview from "./FilePreview.vue";
import FileBrowser from "./FileBrowser.vue";
import WebLink from "./WebLink.vue";
import GoogleDrivePicker from "../../integrations/google_drive_picker";
import ImageCropper from "./ImageCropper.vue";

const __vue_script__ = {
	name: "FileUploader",
	props: {
		show_upload_button: {
			default: true,
		},
		disable_file_browser: {
			default: false,
		},
		allow_multiple: {
			default: true,
		},
		as_dataurl: {
			default: false,
		},
		doctype: {
			default: null,
		},
		docname: {
			default: null,
		},
		fieldname: {
			default: null,
		},
		folder: {
			default: "Home",
		},
		method: {
			default: null,
		},
		on_success: {
			default: null,
		},
		make_attachments_public: {
			default: null,
		},
		restrictions: {
			default: () => ({
				max_file_size: null, // 2048 -> 2KB
				max_number_of_files: null,
				allowed_file_types: [], // ['image/*', 'video/*', '.jpg', '.gif', '.pdf'],
				crop_image_aspect_ratio: null, // 1, 16 / 9, 4 / 3, NaN (free)
			}),
		},
		attach_doc_image: {
			default: false,
		},
		upload_notes: {
			default: null, // "Images or video, upto 2MB"
		},
	},
	components: {
		FilePreview,
		FileBrowser,
		WebLink,
		ImageCropper,
	},
	data() {
		return {
			files: [],
			is_dragging: false,
			currently_uploading: -1,
			show_file_browser: false,
			show_web_link: false,
			show_image_cropper: false,
			crop_image_with_index: -1,
			trigger_upload: false,
			close_dialog: false,
			hide_dialog_footer: false,
			allow_take_photo: false,
			allow_web_link: true,
			google_drive_settings: {
				enabled: false,
			},
			wrapper_ready: false,
		};
	},
	created() {
		this.allow_take_photo = window.navigator.mediaDevices;
		if (frappe.user_id !== "Guest") {
			frappe.call({
				// method only available after login
				method: "frappe.integrations.doctype.google_settings.google_settings.get_file_picker_settings",
				callback: (resp) => {
					if (!resp.exc) {
						this.google_drive_settings = resp.message;
					}
				},
			});
		}
		if (this.restrictions.max_file_size == null) {
			frappe.call("frappe.core.api.file.get_max_file_size").then((res) => {
				this.restrictions.max_file_size = Number(res.message);
			});
		}
		if (this.restrictions.max_number_of_files == null && this.doctype) {
			this.restrictions.max_number_of_files = frappe.get_meta(this.doctype)?.max_attachments;
		}
	},
	watch: {
		files(newvalue, oldvalue) {
			if (!this.allow_multiple && newvalue.length > 1) {
				this.files = [newvalue[newvalue.length - 1]];
			}
		},
	},
	computed: {
		upload_complete() {
			return (
				this.files.length > 0 &&
				this.files.every((file) => file.total !== 0 && file.progress === file.total)
			);
		},
	},
	methods: {
		dragover() {
			this.is_dragging = true;
		},
		dragleave() {
			this.is_dragging = false;
		},
		dropfiles(e) {
			this.is_dragging = false;
			this.add_files(e.dataTransfer.files);
		},
		browse_files() {
			this.$refs.file_input.click();
		},
		on_file_input(e) {
			this.add_files(this.$refs.file_input.files);
		},
		remove_file(file) {
			this.files = this.files.filter((f) => f !== file);
		},
		toggle_image_cropper(index) {
			this.crop_image_with_index = this.show_image_cropper ? -1 : index;
			this.hide_dialog_footer = !this.show_image_cropper;
			this.show_image_cropper = !this.show_image_cropper;
		},
		toggle_all_private() {
			let flag;
			let private_values = this.files.filter((file) => file.private);
			if (private_values.length < this.files.length) {
				// there are some private and some public
				// set all to private
				flag = true;
			} else {
				// all are private, set all to public
				flag = false;
			}
			this.files = this.files.map((file) => {
				file.private = flag;
				return file;
			});
		},
		show_max_files_number_warning(file) {
			console.warn(
				`File skipped because it exceeds the allowed specified limit of ${max_number_of_files} uploads`,
				file
			);
			if (this.doctype) {
				MSG = __(
					'File "{0}" was skipped because only {1} uploads are allowed for DocType "{2}"',
					[file.name, max_number_of_files, this.doctype]
				);
			} else {
				MSG = __('File "{0}" was skipped because only {1} uploads are allowed', [
					file.name,
					max_number_of_files,
				]);
			}
			frappe.show_alert({
				message: MSG,
				indicator: "orange",
			});
		},
		add_files(file_array) {
			let files = Array.from(file_array)
				.filter(this.check_restrictions)
				.map((file) => {
					let is_image = file.type.startsWith("image");
					let size_kb = file.size / 1024;
					return {
						file_obj: file,
						cropper_file: file,
						crop_box_data: null,
						optimize: size_kb > 200 && is_image && !file.type.includes("svg"),
						name: file.name,
						doc: null,
						progress: 0,
						total: 0,
						failed: false,
						request_succeeded: false,
						error_message: null,
						uploading: false,
						private: !this.make_attachments_public,
					};
				});

			// pop extra files as per FileUploader.restrictions.max_number_of_files
			max_number_of_files = this.restrictions.max_number_of_files;
			if (max_number_of_files && files.length > max_number_of_files) {
				files.slice(max_number_of_files).forEach((file) => {
					this.show_max_files_number_warning(file, this.doctype);
				});

				files = files.slice(0, max_number_of_files);
			}

			this.files = this.files.concat(files);
			// if only one file is allowed and crop_image_aspect_ratio is set, open cropper immediately
			if (
				this.files.length === 1 &&
				!this.allow_multiple &&
				this.restrictions.crop_image_aspect_ratio != null
			) {
				if (!this.files[0].file_obj.type.includes("svg")) {
					this.toggle_image_cropper(0);
				}
			}
		},
		check_restrictions(file) {
			let { max_file_size, allowed_file_types = [] } = this.restrictions;

			let is_correct_type = true;
			let valid_file_size = true;

			if (allowed_file_types && allowed_file_types.length) {
				is_correct_type = allowed_file_types.some((type) => {
					// is this is a mime-type
					if (type.includes("/")) {
						if (!file.type) return false;
						return file.type.match(type);
					}

					// otherwise this is likely an extension
					if (type[0] === ".") {
						return file.name.toLowerCase().endsWith(type.toLowerCase());
					}
					return false;
				});
			}

			if (max_file_size && file.size != null) {
				valid_file_size = file.size < max_file_size;
			}

			if (!is_correct_type) {
				console.warn("File skipped because of invalid file type", file);
				frappe.show_alert({
					message: __('File "{0}" was skipped because of invalid file type', [
						file.name,
					]),
					indicator: "orange",
				});
			}
			if (!valid_file_size) {
				console.warn("File skipped because of invalid file size", file.size, file);
				frappe.show_alert({
					message: __('File "{0}" was skipped because size exceeds {1} MB', [
						file.name,
						max_file_size / (1024 * 1024),
					]),
					indicator: "orange",
				});
			}

			return is_correct_type && valid_file_size;
		},
		upload_files() {
			if (this.show_file_browser) {
				return this.upload_via_file_browser();
			}
			if (this.show_web_link) {
				return this.upload_via_web_link();
			}
			if (this.as_dataurl) {
				return this.return_as_dataurl();
			}
			return frappe.run_serially(
				this.files.map((file, i) => () => this.upload_file(file, i))
			);
		},
		upload_via_file_browser() {
			let selected_file = this.$refs.file_browser.selected_node;
			if (!selected_file.value) {
				frappe.msgprint(__("Click on a file to select it."));
				this.close_dialog = true;
				return Promise.reject();
			}
			this.close_dialog = true;
			return this.upload_file({
				library_file_name: selected_file.value,
			});
		},
		upload_via_web_link() {
			let file_url = this.$refs.web_link.url;
			if (!file_url) {
				frappe.msgprint(__("Invalid URL"));
				this.close_dialog = true;
				return Promise.reject();
			}
			file_url = decodeURI(file_url);
			this.close_dialog = true;
			return this.upload_file({
				file_url,
			});
		},
		return_as_dataurl() {
			let promises = this.files.map((file) =>
				frappe.dom.file_to_base64(file.file_obj).then((dataurl) => {
					file.dataurl = dataurl;
					this.on_success && this.on_success(file);
				})
			);
			this.close_dialog = true;
			return Promise.all(promises);
		},
		upload_file(file, i) {
			this.currently_uploading = i;

			return new Promise((resolve, reject) => {
				let xhr = new XMLHttpRequest();
				xhr.upload.addEventListener("loadstart", (e) => {
					file.uploading = true;
				});
				xhr.upload.addEventListener("progress", (e) => {
					if (e.lengthComputable) {
						file.progress = e.loaded;
						file.total = e.total;
					}
				});
				xhr.upload.addEventListener("load", (e) => {
					file.uploading = false;
					resolve();
				});
				xhr.addEventListener("error", (e) => {
					file.failed = true;
					reject();
				});
				xhr.onreadystatechange = () => {
					if (xhr.readyState == XMLHttpRequest.DONE) {
						if (xhr.status === 200) {
							file.request_succeeded = true;
							let r = null;
							let file_doc = null;
							try {
								r = JSON.parse(xhr.responseText);
								if (r.message.doctype === "File") {
									file_doc = r.message;
								}
							} catch (e) {
								r = xhr.responseText;
							}

							file.doc = file_doc;

							if (this.on_success) {
								this.on_success(file_doc, r);
							}

							if (
								i == this.files.length - 1 &&
								this.files.every((file) => file.request_succeeded)
							) {
								this.close_dialog = true;
							}
						} else if (xhr.status === 403) {
							file.failed = true;
							let response = JSON.parse(xhr.responseText);
							file.error_message = `Not permitted. ${response._error_message || ""}`;
						} else if (xhr.status === 413) {
							file.failed = true;
							file.error_message = "Size exceeds the maximum allowed file size.";
						} else {
							file.failed = true;
							file.error_message =
								xhr.status === 0
									? "XMLHttpRequest Error"
									: `${xhr.status} : ${xhr.statusText}`;

							let error = null;
							try {
								error = JSON.parse(xhr.responseText);
							} catch (e) {
								// pass
							}
							frappe.request.cleanup({}, error);
						}
					}
				};
				xhr.open("POST", "/api/method/upload_file", true);
				xhr.setRequestHeader("Accept", "application/json");
				xhr.setRequestHeader("X-Frappe-CSRF-Token", frappe.csrf_token);

				let form_data = new FormData();
				if (file.file_obj) {
					form_data.append("file", file.file_obj, file.name);
				}
				form_data.append("is_private", +file.private);
				form_data.append("folder", this.folder);

				if (file.file_url) {
					form_data.append("file_url", file.file_url);
				}

				if (file.file_name) {
					form_data.append("file_name", file.file_name);
				}

				if (file.library_file_name) {
					form_data.append("library_file_name", file.library_file_name);
				}

				if (this.doctype && this.docname) {
					form_data.append("doctype", this.doctype);
					form_data.append("docname", this.docname);
				}

				if (this.fieldname) {
					form_data.append("fieldname", this.fieldname);
				}

				if (this.method) {
					form_data.append("method", this.method);
				}

				if (file.optimize) {
					form_data.append("optimize", true);
				}

				if (this.attach_doc_image) {
					form_data.append("max_width", 200);
					form_data.append("max_height", 200);
				}

				xhr.send(form_data);
			});
		},
		capture_image() {
			const capture = new frappe.ui.Capture({
				animate: false,
				error: true,
			});
			capture.show();
			capture.submit((data_urls) => {
				data_urls.forEach((data_url) => {
					let filename = `capture_${frappe.datetime
						.now_datetime()
						.replaceAll(/[: -]/g, "_")}.png`;
					this.url_to_file(data_url, filename, "image/png").then((file) =>
						this.add_files([file])
					);
				});
			});
		},
		show_google_drive_picker() {
			this.close_dialog = true;
			let google_drive = new GoogleDrivePicker({
				pickerCallback: (data) => this.google_drive_callback(data),
				...this.google_drive_settings,
			});
			google_drive.loadPicker();
		},
		google_drive_callback(data) {
			if (data.action == google.picker.Action.PICKED) {
				this.upload_file({
					file_url: data.docs[0].url,
					file_name: data.docs[0].name,
				});
			} else if (data.action == google.picker.Action.CANCEL) {
				cur_frm.attachments.new_attachment();
			}
		},
		url_to_file(url, filename, mime_type) {
			return fetch(url)
				.then((res) => res.arrayBuffer())
				.then((buffer) => new File([buffer], filename, { type: mime_type }));
		},
	},
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "file-uploader",
      on: {
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.dragover.apply(null, arguments)
        },
        dragleave: function ($event) {
          $event.preventDefault()
          return _vm.dragleave.apply(null, arguments)
        },
        drop: function ($event) {
          $event.preventDefault()
          return _vm.dropfiles.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.files.length === 0 &&
                !_vm.show_file_browser &&
                !_vm.show_web_link,
              expression:
                "files.length === 0 && !show_file_browser && !show_web_link",
            },
          ],
          staticClass: "file-upload-area",
        },
        [
          !_vm.is_dragging
            ? _c("div", [
                _c("div", { staticClass: "text-center" }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.__("Drag and drop files here or upload from")
                      ) +
                      "\n\t\t\t"
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "mt-3 text-center" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-file-upload",
                      on: { click: _vm.browse_files },
                    },
                    [
                      _c(
                        "svg",
                        {
                          attrs: {
                            width: "30",
                            height: "30",
                            viewBox: "0 0 30 30",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: {
                              cx: "15",
                              cy: "15",
                              r: "15",
                              fill: "url(#paint0_linear)",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M13.5 22V19",
                              stroke: "white",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M16.5 22V19",
                              stroke: "white",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M10.5 22H19.5",
                              stroke: "white",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M7.5 16H22.5",
                              stroke: "white",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M21 8H9C8.17157 8 7.5 8.67157 7.5 9.5V17.5C7.5 18.3284 8.17157 19 9 19H21C21.8284 19 22.5 18.3284 22.5 17.5V9.5C22.5 8.67157 21.8284 8 21 8Z",
                              stroke: "white",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "defs",
                            [
                              _c(
                                "linearGradient",
                                {
                                  attrs: {
                                    id: "paint0_linear",
                                    x1: "0",
                                    y1: "0",
                                    x2: "0",
                                    y2: "30",
                                    gradientUnits: "userSpaceOnUse",
                                  },
                                },
                                [
                                  _c("stop", {
                                    attrs: { "stop-color": "#2C9AF1" },
                                  }),
                                  _vm._v(" "),
                                  _c("stop", {
                                    attrs: {
                                      offset: "1",
                                      "stop-color": "#2490EF",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "mt-1" }, [
                        _vm._v(_vm._s(_vm.__("My Device"))),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c("input", {
                    ref: "file_input",
                    staticClass: "hidden",
                    attrs: {
                      type: "file",
                      multiple: _vm.allow_multiple,
                      accept: (_vm.restrictions.allowed_file_types || []).join(
                        ", "
                      ),
                    },
                    on: { change: _vm.on_file_input },
                  }),
                  _vm._v(" "),
                  !_vm.disable_file_browser
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-file-upload",
                          on: {
                            click: function ($event) {
                              _vm.show_file_browser = true
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "30",
                                height: "30",
                                viewBox: "0 0 30 30",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "15",
                                  cy: "15",
                                  r: "15",
                                  fill: "#48BB74",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M13.0245 11.5H8C7.72386 11.5 7.5 11.7239 7.5 12V20C7.5 21.1046 8.39543 22 9.5 22H20.5C21.6046 22 22.5 21.1046 22.5 20V14.5C22.5 14.2239 22.2761 14 22 14H15.2169C15.0492 14 14.8926 13.9159 14.8 13.776L13.4414 11.724C13.3488 11.5841 13.1922 11.5 13.0245 11.5Z",
                                  stroke: "white",
                                  "stroke-miterlimit": "10",
                                  "stroke-linecap": "square",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M8.87939 9.5V8.5C8.87939 8.22386 9.10325 8 9.37939 8H20.6208C20.8969 8 21.1208 8.22386 21.1208 8.5V12",
                                  stroke: "white",
                                  "stroke-miterlimit": "10",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-1" }, [
                            _vm._v(_vm._s(_vm.__("Library"))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.allow_web_link
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-file-upload",
                          on: {
                            click: function ($event) {
                              _vm.show_web_link = true
                            },
                          },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "30",
                                height: "30",
                                viewBox: "0 0 30 30",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "15",
                                  cy: "15",
                                  r: "15",
                                  fill: "#ECAC4B",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M12.0469 17.9543L17.9558 12.0454",
                                  stroke: "white",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M13.8184 11.4547L15.7943 9.47873C16.4212 8.85205 17.2714 8.5 18.1578 8.5C19.0443 8.5 19.8945 8.85205 20.5214 9.47873V9.47873C21.1481 10.1057 21.5001 10.9558 21.5001 11.8423C21.5001 12.7287 21.1481 13.5789 20.5214 14.2058L18.5455 16.1818",
                                  stroke: "white",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M11.4547 13.8184L9.47873 15.7943C8.85205 16.4212 8.5 17.2714 8.5 18.1578C8.5 19.0443 8.85205 19.8945 9.47873 20.5214V20.5214C10.1057 21.1481 10.9558 21.5001 11.8423 21.5001C12.7287 21.5001 13.5789 21.1481 14.2058 20.5214L16.1818 18.5455",
                                  stroke: "white",
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-1" }, [
                            _vm._v(_vm._s(_vm.__("Link"))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.allow_take_photo
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-file-upload",
                          on: { click: _vm.capture_image },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "30",
                                height: "30",
                                viewBox: "0 0 30 30",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c("circle", {
                                attrs: {
                                  cx: "15",
                                  cy: "15",
                                  r: "15",
                                  fill: "#CE315B",
                                },
                              }),
                              _vm._v(" "),
                              _c("path", {
                                attrs: {
                                  d: "M11.5 10.5H9.5C8.67157 10.5 8 11.1716 8 12V20C8 20.8284 8.67157 21.5 9.5 21.5H20.5C21.3284 21.5 22 20.8284 22 20V12C22 11.1716 21.3284 10.5 20.5 10.5H18.5L17.3 8.9C17.1111 8.64819 16.8148 8.5 16.5 8.5H13.5C13.1852 8.5 12.8889 8.64819 12.7 8.9L11.5 10.5Z",
                                  stroke: "white",
                                  "stroke-linejoin": "round",
                                },
                              }),
                              _vm._v(" "),
                              _c("circle", {
                                attrs: {
                                  cx: "15",
                                  cy: "16",
                                  r: "2.5",
                                  stroke: "white",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-1" }, [
                            _vm._v(_vm._s(_vm.__("Camera"))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.google_drive_settings.enabled
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-file-upload",
                          on: { click: _vm.show_google_drive_picker },
                        },
                        [
                          _c("svg", { attrs: { width: "30", height: "30" } }, [
                            _c("image", {
                              attrs: {
                                href: "/assets/frappe/icons/social/google_drive.svg",
                                width: "30",
                                height: "30",
                              },
                            }),
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "mt-1" }, [
                            _vm._v(_vm._s(_vm.__("Google Drive"))),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _vm.upload_notes
                  ? _c("div", { staticClass: "mt-3 text-center" }, [
                      _vm._v(
                        "\n\t\t\t\t" + _vm._s(_vm.upload_notes) + "\n\t\t\t"
                      ),
                    ])
                  : _vm._e(),
              ])
            : _c("div", [
                _vm._v(
                  "\n\t\t\t" + _vm._s(_vm.__("Drop files here")) + "\n\t\t"
                ),
              ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.files.length &&
                !_vm.show_file_browser &&
                !_vm.show_web_link,
              expression:
                "files.length && !show_file_browser && !show_web_link",
            },
          ],
          staticClass: "file-preview-area",
        },
        [
          !_vm.show_image_cropper
            ? _c(
                "div",
                { staticClass: "file-preview-container" },
                _vm._l(_vm.files, function (file, i) {
                  return _c("FilePreview", {
                    key: file.name,
                    attrs: { file: file },
                    on: {
                      remove: function ($event) {
                        return _vm.remove_file(file)
                      },
                      toggle_private: function ($event) {
                        file.private = !file.private
                      },
                      toggle_optimize: function ($event) {
                        file.optimize = !file.optimize
                      },
                      toggle_image_cropper: function ($event) {
                        return _vm.toggle_image_cropper(i)
                      },
                    },
                  })
                }),
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.show_upload_button && _vm.currently_uploading === -1
            ? _c("div", { staticClass: "flex align-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-sm margin-right",
                    on: {
                      click: function () {
                        return _vm.upload_files()
                      },
                    },
                  },
                  [
                    _vm.files.length === 1
                      ? _c("span", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(_vm.__("Upload file")) +
                              "\n\t\t\t\t"
                          ),
                        ])
                      : _c("span", [
                          _vm._v(
                            "\n\t\t\t\t\t" +
                              _vm._s(
                                _vm.__("Upload {0} files", [_vm.files.length])
                              ) +
                              "\n\t\t\t\t"
                          ),
                        ]),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "text-muted text-medium" }, [
                  _vm._v(
                    "\n\t\t\t\t" +
                      _vm._s(
                        _vm.__(
                          "Click on the lock icon to toggle public/private"
                        )
                      ) +
                      "\n\t\t\t"
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _vm.show_image_cropper && _vm.wrapper_ready
        ? _c("ImageCropper", {
            attrs: {
              file: _vm.files[_vm.crop_image_with_index],
              fixed_aspect_ratio: _vm.restrictions.crop_image_aspect_ratio,
            },
            on: {
              toggle_image_cropper: function ($event) {
                return _vm.toggle_image_cropper(-1)
              },
              upload_after_crop: function ($event) {
                _vm.trigger_upload = true
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.show_file_browser && !_vm.disable_file_browser
        ? _c("FileBrowser", {
            ref: "file_browser",
            on: {
              "hide-browser": function ($event) {
                _vm.show_file_browser = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.show_web_link
        ? _c("WebLink", {
            ref: "web_link",
            on: {
              "hide-web-link": function ($event) {
                _vm.show_web_link = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-07fa0eaa_0", { source: "\n.file-upload-area {\n\tmin-height: 16rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: 1px dashed var(--dark-border-color);\n\tborder-radius: var(--border-radius);\n\tcursor: pointer;\n\tbackground-color: var(--bg-color);\n}\n.btn-file-upload {\n\tbackground-color: transparent;\n\tborder: none;\n\tbox-shadow: none;\n\tfont-size: var(--text-xs);\n}\n", map: {"version":3,"sources":["frappe/public/js/frappe/file_uploader/FileUploader.vue"],"names":[],"mappings":";AAktBA;CACA,iBAAA;CACA,aAAA;CACA,mBAAA;CACA,uBAAA;CACA,2CAAA;CACA,mCAAA;CACA,eAAA;CACA,iCAAA;AACA;AAEA;CACA,6BAAA;CACA,YAAA;CACA,gBAAA;CACA,yBAAA;AACA","file":"FileUploader.vue","sourcesContent":["<template>\n\t<div\n\t\tclass=\"file-uploader\"\n\t\t@dragover.prevent=\"dragover\"\n\t\t@dragleave.prevent=\"dragleave\"\n\t\t@drop.prevent=\"dropfiles\"\n\t>\n\t\t<div\n\t\t\tclass=\"file-upload-area\"\n\t\t\tv-show=\"files.length === 0 && !show_file_browser && !show_web_link\"\n\t\t>\n\t\t\t<div v-if=\"!is_dragging\">\n\t\t\t\t<div class=\"text-center\">\n\t\t\t\t\t{{ __(\"Drag and drop files here or upload from\") }}\n\t\t\t\t</div>\n\t\t\t\t<div class=\"mt-3 text-center\">\n\t\t\t\t\t<button class=\"btn btn-file-upload\" @click=\"browse_files\">\n\t\t\t\t\t\t<svg\n\t\t\t\t\t\t\twidth=\"30\"\n\t\t\t\t\t\t\theight=\"30\"\n\t\t\t\t\t\t\tviewBox=\"0 0 30 30\"\n\t\t\t\t\t\t\tfill=\"none\"\n\t\t\t\t\t\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"url(#paint0_linear)\" />\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M13.5 22V19\"\n\t\t\t\t\t\t\t\tstroke=\"white\"\n\t\t\t\t\t\t\t\tstroke-linecap=\"round\"\n\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M16.5 22V19\"\n\t\t\t\t\t\t\t\tstroke=\"white\"\n\t\t\t\t\t\t\t\tstroke-linecap=\"round\"\n\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M10.5 22H19.5\"\n\t\t\t\t\t\t\t\tstroke=\"white\"\n\t\t\t\t\t\t\t\tstroke-linecap=\"round\"\n\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M7.5 16H22.5\"\n\t\t\t\t\t\t\t\tstroke=\"white\"\n\t\t\t\t\t\t\t\tstroke-linecap=\"round\"\n\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M21 8H9C8.17157 8 7.5 8.67157 7.5 9.5V17.5C7.5 18.3284 8.17157 19 9 19H21C21.8284 19 22.5 18.3284 22.5 17.5V9.5C22.5 8.67157 21.8284 8 21 8Z\"\n\t\t\t\t\t\t\t\tstroke=\"white\"\n\t\t\t\t\t\t\t\tstroke-linecap=\"round\"\n\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<defs>\n\t\t\t\t\t\t\t\t<linearGradient\n\t\t\t\t\t\t\t\t\tid=\"paint0_linear\"\n\t\t\t\t\t\t\t\t\tx1=\"0\"\n\t\t\t\t\t\t\t\t\ty1=\"0\"\n\t\t\t\t\t\t\t\t\tx2=\"0\"\n\t\t\t\t\t\t\t\t\ty2=\"30\"\n\t\t\t\t\t\t\t\t\tgradientUnits=\"userSpaceOnUse\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t\t<stop stop-color=\"#2C9AF1\" />\n\t\t\t\t\t\t\t\t\t<stop offset=\"1\" stop-color=\"#2490EF\" />\n\t\t\t\t\t\t\t\t</linearGradient>\n\t\t\t\t\t\t\t</defs>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t<div class=\"mt-1\">{{ __(\"My Device\") }}</div>\n\t\t\t\t\t</button>\n\t\t\t\t\t<input\n\t\t\t\t\t\ttype=\"file\"\n\t\t\t\t\t\tclass=\"hidden\"\n\t\t\t\t\t\tref=\"file_input\"\n\t\t\t\t\t\t@change=\"on_file_input\"\n\t\t\t\t\t\t:multiple=\"allow_multiple\"\n\t\t\t\t\t\t:accept=\"(restrictions.allowed_file_types || []).join(', ')\"\n\t\t\t\t\t/>\n\t\t\t\t\t<button\n\t\t\t\t\t\tclass=\"btn btn-file-upload\"\n\t\t\t\t\t\tv-if=\"!disable_file_browser\"\n\t\t\t\t\t\t@click=\"show_file_browser = true\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<svg\n\t\t\t\t\t\t\twidth=\"30\"\n\t\t\t\t\t\t\theight=\"30\"\n\t\t\t\t\t\t\tviewBox=\"0 0 30 30\"\n\t\t\t\t\t\t\tfill=\"none\"\n\t\t\t\t\t\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"#48BB74\" />\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M13.0245 11.5H8C7.72386 11.5 7.5 11.7239 7.5 12V20C7.5 21.1046 8.39543 22 9.5 22H20.5C21.6046 22 22.5 21.1046 22.5 20V14.5C22.5 14.2239 22.2761 14 22 14H15.2169C15.0492 14 14.8926 13.9159 14.8 13.776L13.4414 11.724C13.3488 11.5841 13.1922 11.5 13.0245 11.5Z\"\n\t\t\t\t\t\t\t\tstroke=\"white\"\n\t\t\t\t\t\t\t\tstroke-miterlimit=\"10\"\n\t\t\t\t\t\t\t\tstroke-linecap=\"square\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M8.87939 9.5V8.5C8.87939 8.22386 9.10325 8 9.37939 8H20.6208C20.8969 8 21.1208 8.22386 21.1208 8.5V12\"\n\t\t\t\t\t\t\t\tstroke=\"white\"\n\t\t\t\t\t\t\t\tstroke-miterlimit=\"10\"\n\t\t\t\t\t\t\t\tstroke-linecap=\"round\"\n\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t<div class=\"mt-1\">{{ __(\"Library\") }}</div>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button\n\t\t\t\t\t\tclass=\"btn btn-file-upload\"\n\t\t\t\t\t\tv-if=\"allow_web_link\"\n\t\t\t\t\t\t@click=\"show_web_link = true\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<svg\n\t\t\t\t\t\t\twidth=\"30\"\n\t\t\t\t\t\t\theight=\"30\"\n\t\t\t\t\t\t\tviewBox=\"0 0 30 30\"\n\t\t\t\t\t\t\tfill=\"none\"\n\t\t\t\t\t\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"#ECAC4B\" />\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M12.0469 17.9543L17.9558 12.0454\"\n\t\t\t\t\t\t\t\tstroke=\"white\"\n\t\t\t\t\t\t\t\tstroke-linecap=\"round\"\n\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M13.8184 11.4547L15.7943 9.47873C16.4212 8.85205 17.2714 8.5 18.1578 8.5C19.0443 8.5 19.8945 8.85205 20.5214 9.47873V9.47873C21.1481 10.1057 21.5001 10.9558 21.5001 11.8423C21.5001 12.7287 21.1481 13.5789 20.5214 14.2058L18.5455 16.1818\"\n\t\t\t\t\t\t\t\tstroke=\"white\"\n\t\t\t\t\t\t\t\tstroke-linecap=\"round\"\n\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M11.4547 13.8184L9.47873 15.7943C8.85205 16.4212 8.5 17.2714 8.5 18.1578C8.5 19.0443 8.85205 19.8945 9.47873 20.5214V20.5214C10.1057 21.1481 10.9558 21.5001 11.8423 21.5001C12.7287 21.5001 13.5789 21.1481 14.2058 20.5214L16.1818 18.5455\"\n\t\t\t\t\t\t\t\tstroke=\"white\"\n\t\t\t\t\t\t\t\tstroke-linecap=\"round\"\n\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t<div class=\"mt-1\">{{ __(\"Link\") }}</div>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button\n\t\t\t\t\t\tv-if=\"allow_take_photo\"\n\t\t\t\t\t\tclass=\"btn btn-file-upload\"\n\t\t\t\t\t\t@click=\"capture_image\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<svg\n\t\t\t\t\t\t\twidth=\"30\"\n\t\t\t\t\t\t\theight=\"30\"\n\t\t\t\t\t\t\tviewBox=\"0 0 30 30\"\n\t\t\t\t\t\t\tfill=\"none\"\n\t\t\t\t\t\t\txmlns=\"http://www.w3.org/2000/svg\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<circle cx=\"15\" cy=\"15\" r=\"15\" fill=\"#CE315B\" />\n\t\t\t\t\t\t\t<path\n\t\t\t\t\t\t\t\td=\"M11.5 10.5H9.5C8.67157 10.5 8 11.1716 8 12V20C8 20.8284 8.67157 21.5 9.5 21.5H20.5C21.3284 21.5 22 20.8284 22 20V12C22 11.1716 21.3284 10.5 20.5 10.5H18.5L17.3 8.9C17.1111 8.64819 16.8148 8.5 16.5 8.5H13.5C13.1852 8.5 12.8889 8.64819 12.7 8.9L11.5 10.5Z\"\n\t\t\t\t\t\t\t\tstroke=\"white\"\n\t\t\t\t\t\t\t\tstroke-linejoin=\"round\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t\t<circle cx=\"15\" cy=\"16\" r=\"2.5\" stroke=\"white\" />\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t<div class=\"mt-1\">{{ __(\"Camera\") }}</div>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button\n\t\t\t\t\t\tv-if=\"google_drive_settings.enabled\"\n\t\t\t\t\t\tclass=\"btn btn-file-upload\"\n\t\t\t\t\t\t@click=\"show_google_drive_picker\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<svg width=\"30\" height=\"30\">\n\t\t\t\t\t\t\t<image\n\t\t\t\t\t\t\t\thref=\"/assets/frappe/icons/social/google_drive.svg\"\n\t\t\t\t\t\t\t\twidth=\"30\"\n\t\t\t\t\t\t\t\theight=\"30\"\n\t\t\t\t\t\t\t/>\n\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t<div class=\"mt-1\">{{ __(\"Google Drive\") }}</div>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t\t<div class=\"mt-3 text-center\" v-if=\"upload_notes\">\n\t\t\t\t\t{{ upload_notes }}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t\t<div v-else>\n\t\t\t\t{{ __(\"Drop files here\") }}\n\t\t\t</div>\n\t\t</div>\n\t\t<div\n\t\t\tclass=\"file-preview-area\"\n\t\t\tv-show=\"files.length && !show_file_browser && !show_web_link\"\n\t\t>\n\t\t\t<div class=\"file-preview-container\" v-if=\"!show_image_cropper\">\n\t\t\t\t<FilePreview\n\t\t\t\t\tv-for=\"(file, i) in files\"\n\t\t\t\t\t:key=\"file.name\"\n\t\t\t\t\t:file=\"file\"\n\t\t\t\t\t@remove=\"remove_file(file)\"\n\t\t\t\t\t@toggle_private=\"file.private = !file.private\"\n\t\t\t\t\t@toggle_optimize=\"file.optimize = !file.optimize\"\n\t\t\t\t\t@toggle_image_cropper=\"toggle_image_cropper(i)\"\n\t\t\t\t/>\n\t\t\t</div>\n\t\t\t<div class=\"flex align-center\" v-if=\"show_upload_button && currently_uploading === -1\">\n\t\t\t\t<button class=\"btn btn-primary btn-sm margin-right\" @click=\"() => upload_files()\">\n\t\t\t\t\t<span v-if=\"files.length === 1\">\n\t\t\t\t\t\t{{ __(\"Upload file\") }}\n\t\t\t\t\t</span>\n\t\t\t\t\t<span v-else>\n\t\t\t\t\t\t{{ __(\"Upload {0} files\", [files.length]) }}\n\t\t\t\t\t</span>\n\t\t\t\t</button>\n\t\t\t\t<div class=\"text-muted text-medium\">\n\t\t\t\t\t{{ __(\"Click on the lock icon to toggle public/private\") }}\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t\t<ImageCropper\n\t\t\tv-if=\"show_image_cropper && wrapper_ready\"\n\t\t\t:file=\"files[crop_image_with_index]\"\n\t\t\t:fixed_aspect_ratio=\"restrictions.crop_image_aspect_ratio\"\n\t\t\t@toggle_image_cropper=\"toggle_image_cropper(-1)\"\n\t\t\t@upload_after_crop=\"trigger_upload = true\"\n\t\t/>\n\t\t<FileBrowser\n\t\t\tref=\"file_browser\"\n\t\t\tv-if=\"show_file_browser && !disable_file_browser\"\n\t\t\t@hide-browser=\"show_file_browser = false\"\n\t\t/>\n\t\t<WebLink ref=\"web_link\" v-if=\"show_web_link\" @hide-web-link=\"show_web_link = false\" />\n\t</div>\n</template>\n\n<script>\nimport FilePreview from \"./FilePreview.vue\";\nimport FileBrowser from \"./FileBrowser.vue\";\nimport WebLink from \"./WebLink.vue\";\nimport GoogleDrivePicker from \"../../integrations/google_drive_picker\";\nimport ImageCropper from \"./ImageCropper.vue\";\n\nexport default {\n\tname: \"FileUploader\",\n\tprops: {\n\t\tshow_upload_button: {\n\t\t\tdefault: true,\n\t\t},\n\t\tdisable_file_browser: {\n\t\t\tdefault: false,\n\t\t},\n\t\tallow_multiple: {\n\t\t\tdefault: true,\n\t\t},\n\t\tas_dataurl: {\n\t\t\tdefault: false,\n\t\t},\n\t\tdoctype: {\n\t\t\tdefault: null,\n\t\t},\n\t\tdocname: {\n\t\t\tdefault: null,\n\t\t},\n\t\tfieldname: {\n\t\t\tdefault: null,\n\t\t},\n\t\tfolder: {\n\t\t\tdefault: \"Home\",\n\t\t},\n\t\tmethod: {\n\t\t\tdefault: null,\n\t\t},\n\t\ton_success: {\n\t\t\tdefault: null,\n\t\t},\n\t\tmake_attachments_public: {\n\t\t\tdefault: null,\n\t\t},\n\t\trestrictions: {\n\t\t\tdefault: () => ({\n\t\t\t\tmax_file_size: null, // 2048 -> 2KB\n\t\t\t\tmax_number_of_files: null,\n\t\t\t\tallowed_file_types: [], // ['image/*', 'video/*', '.jpg', '.gif', '.pdf'],\n\t\t\t\tcrop_image_aspect_ratio: null, // 1, 16 / 9, 4 / 3, NaN (free)\n\t\t\t}),\n\t\t},\n\t\tattach_doc_image: {\n\t\t\tdefault: false,\n\t\t},\n\t\tupload_notes: {\n\t\t\tdefault: null, // \"Images or video, upto 2MB\"\n\t\t},\n\t},\n\tcomponents: {\n\t\tFilePreview,\n\t\tFileBrowser,\n\t\tWebLink,\n\t\tImageCropper,\n\t},\n\tdata() {\n\t\treturn {\n\t\t\tfiles: [],\n\t\t\tis_dragging: false,\n\t\t\tcurrently_uploading: -1,\n\t\t\tshow_file_browser: false,\n\t\t\tshow_web_link: false,\n\t\t\tshow_image_cropper: false,\n\t\t\tcrop_image_with_index: -1,\n\t\t\ttrigger_upload: false,\n\t\t\tclose_dialog: false,\n\t\t\thide_dialog_footer: false,\n\t\t\tallow_take_photo: false,\n\t\t\tallow_web_link: true,\n\t\t\tgoogle_drive_settings: {\n\t\t\t\tenabled: false,\n\t\t\t},\n\t\t\twrapper_ready: false,\n\t\t};\n\t},\n\tcreated() {\n\t\tthis.allow_take_photo = window.navigator.mediaDevices;\n\t\tif (frappe.user_id !== \"Guest\") {\n\t\t\tfrappe.call({\n\t\t\t\t// method only available after login\n\t\t\t\tmethod: \"frappe.integrations.doctype.google_settings.google_settings.get_file_picker_settings\",\n\t\t\t\tcallback: (resp) => {\n\t\t\t\t\tif (!resp.exc) {\n\t\t\t\t\t\tthis.google_drive_settings = resp.message;\n\t\t\t\t\t}\n\t\t\t\t},\n\t\t\t});\n\t\t}\n\t\tif (this.restrictions.max_file_size == null) {\n\t\t\tfrappe.call(\"frappe.core.api.file.get_max_file_size\").then((res) => {\n\t\t\t\tthis.restrictions.max_file_size = Number(res.message);\n\t\t\t});\n\t\t}\n\t\tif (this.restrictions.max_number_of_files == null && this.doctype) {\n\t\t\tthis.restrictions.max_number_of_files = frappe.get_meta(this.doctype)?.max_attachments;\n\t\t}\n\t},\n\twatch: {\n\t\tfiles(newvalue, oldvalue) {\n\t\t\tif (!this.allow_multiple && newvalue.length > 1) {\n\t\t\t\tthis.files = [newvalue[newvalue.length - 1]];\n\t\t\t}\n\t\t},\n\t},\n\tcomputed: {\n\t\tupload_complete() {\n\t\t\treturn (\n\t\t\t\tthis.files.length > 0 &&\n\t\t\t\tthis.files.every((file) => file.total !== 0 && file.progress === file.total)\n\t\t\t);\n\t\t},\n\t},\n\tmethods: {\n\t\tdragover() {\n\t\t\tthis.is_dragging = true;\n\t\t},\n\t\tdragleave() {\n\t\t\tthis.is_dragging = false;\n\t\t},\n\t\tdropfiles(e) {\n\t\t\tthis.is_dragging = false;\n\t\t\tthis.add_files(e.dataTransfer.files);\n\t\t},\n\t\tbrowse_files() {\n\t\t\tthis.$refs.file_input.click();\n\t\t},\n\t\ton_file_input(e) {\n\t\t\tthis.add_files(this.$refs.file_input.files);\n\t\t},\n\t\tremove_file(file) {\n\t\t\tthis.files = this.files.filter((f) => f !== file);\n\t\t},\n\t\ttoggle_image_cropper(index) {\n\t\t\tthis.crop_image_with_index = this.show_image_cropper ? -1 : index;\n\t\t\tthis.hide_dialog_footer = !this.show_image_cropper;\n\t\t\tthis.show_image_cropper = !this.show_image_cropper;\n\t\t},\n\t\ttoggle_all_private() {\n\t\t\tlet flag;\n\t\t\tlet private_values = this.files.filter((file) => file.private);\n\t\t\tif (private_values.length < this.files.length) {\n\t\t\t\t// there are some private and some public\n\t\t\t\t// set all to private\n\t\t\t\tflag = true;\n\t\t\t} else {\n\t\t\t\t// all are private, set all to public\n\t\t\t\tflag = false;\n\t\t\t}\n\t\t\tthis.files = this.files.map((file) => {\n\t\t\t\tfile.private = flag;\n\t\t\t\treturn file;\n\t\t\t});\n\t\t},\n\t\tshow_max_files_number_warning(file) {\n\t\t\tconsole.warn(\n\t\t\t\t`File skipped because it exceeds the allowed specified limit of ${max_number_of_files} uploads`,\n\t\t\t\tfile\n\t\t\t);\n\t\t\tif (this.doctype) {\n\t\t\t\tMSG = __(\n\t\t\t\t\t'File \"{0}\" was skipped because only {1} uploads are allowed for DocType \"{2}\"',\n\t\t\t\t\t[file.name, max_number_of_files, this.doctype]\n\t\t\t\t);\n\t\t\t} else {\n\t\t\t\tMSG = __('File \"{0}\" was skipped because only {1} uploads are allowed', [\n\t\t\t\t\tfile.name,\n\t\t\t\t\tmax_number_of_files,\n\t\t\t\t]);\n\t\t\t}\n\t\t\tfrappe.show_alert({\n\t\t\t\tmessage: MSG,\n\t\t\t\tindicator: \"orange\",\n\t\t\t});\n\t\t},\n\t\tadd_files(file_array) {\n\t\t\tlet files = Array.from(file_array)\n\t\t\t\t.filter(this.check_restrictions)\n\t\t\t\t.map((file) => {\n\t\t\t\t\tlet is_image = file.type.startsWith(\"image\");\n\t\t\t\t\tlet size_kb = file.size / 1024;\n\t\t\t\t\treturn {\n\t\t\t\t\t\tfile_obj: file,\n\t\t\t\t\t\tcropper_file: file,\n\t\t\t\t\t\tcrop_box_data: null,\n\t\t\t\t\t\toptimize: size_kb > 200 && is_image && !file.type.includes(\"svg\"),\n\t\t\t\t\t\tname: file.name,\n\t\t\t\t\t\tdoc: null,\n\t\t\t\t\t\tprogress: 0,\n\t\t\t\t\t\ttotal: 0,\n\t\t\t\t\t\tfailed: false,\n\t\t\t\t\t\trequest_succeeded: false,\n\t\t\t\t\t\terror_message: null,\n\t\t\t\t\t\tuploading: false,\n\t\t\t\t\t\tprivate: !this.make_attachments_public,\n\t\t\t\t\t};\n\t\t\t\t});\n\n\t\t\t// pop extra files as per FileUploader.restrictions.max_number_of_files\n\t\t\tmax_number_of_files = this.restrictions.max_number_of_files;\n\t\t\tif (max_number_of_files && files.length > max_number_of_files) {\n\t\t\t\tfiles.slice(max_number_of_files).forEach((file) => {\n\t\t\t\t\tthis.show_max_files_number_warning(file, this.doctype);\n\t\t\t\t});\n\n\t\t\t\tfiles = files.slice(0, max_number_of_files);\n\t\t\t}\n\n\t\t\tthis.files = this.files.concat(files);\n\t\t\t// if only one file is allowed and crop_image_aspect_ratio is set, open cropper immediately\n\t\t\tif (\n\t\t\t\tthis.files.length === 1 &&\n\t\t\t\t!this.allow_multiple &&\n\t\t\t\tthis.restrictions.crop_image_aspect_ratio != null\n\t\t\t) {\n\t\t\t\tif (!this.files[0].file_obj.type.includes(\"svg\")) {\n\t\t\t\t\tthis.toggle_image_cropper(0);\n\t\t\t\t}\n\t\t\t}\n\t\t},\n\t\tcheck_restrictions(file) {\n\t\t\tlet { max_file_size, allowed_file_types = [] } = this.restrictions;\n\n\t\t\tlet is_correct_type = true;\n\t\t\tlet valid_file_size = true;\n\n\t\t\tif (allowed_file_types && allowed_file_types.length) {\n\t\t\t\tis_correct_type = allowed_file_types.some((type) => {\n\t\t\t\t\t// is this is a mime-type\n\t\t\t\t\tif (type.includes(\"/\")) {\n\t\t\t\t\t\tif (!file.type) return false;\n\t\t\t\t\t\treturn file.type.match(type);\n\t\t\t\t\t}\n\n\t\t\t\t\t// otherwise this is likely an extension\n\t\t\t\t\tif (type[0] === \".\") {\n\t\t\t\t\t\treturn file.name.toLowerCase().endsWith(type.toLowerCase());\n\t\t\t\t\t}\n\t\t\t\t\treturn false;\n\t\t\t\t});\n\t\t\t}\n\n\t\t\tif (max_file_size && file.size != null) {\n\t\t\t\tvalid_file_size = file.size < max_file_size;\n\t\t\t}\n\n\t\t\tif (!is_correct_type) {\n\t\t\t\tconsole.warn(\"File skipped because of invalid file type\", file);\n\t\t\t\tfrappe.show_alert({\n\t\t\t\t\tmessage: __('File \"{0}\" was skipped because of invalid file type', [\n\t\t\t\t\t\tfile.name,\n\t\t\t\t\t]),\n\t\t\t\t\tindicator: \"orange\",\n\t\t\t\t});\n\t\t\t}\n\t\t\tif (!valid_file_size) {\n\t\t\t\tconsole.warn(\"File skipped because of invalid file size\", file.size, file);\n\t\t\t\tfrappe.show_alert({\n\t\t\t\t\tmessage: __('File \"{0}\" was skipped because size exceeds {1} MB', [\n\t\t\t\t\t\tfile.name,\n\t\t\t\t\t\tmax_file_size / (1024 * 1024),\n\t\t\t\t\t]),\n\t\t\t\t\tindicator: \"orange\",\n\t\t\t\t});\n\t\t\t}\n\n\t\t\treturn is_correct_type && valid_file_size;\n\t\t},\n\t\tupload_files() {\n\t\t\tif (this.show_file_browser) {\n\t\t\t\treturn this.upload_via_file_browser();\n\t\t\t}\n\t\t\tif (this.show_web_link) {\n\t\t\t\treturn this.upload_via_web_link();\n\t\t\t}\n\t\t\tif (this.as_dataurl) {\n\t\t\t\treturn this.return_as_dataurl();\n\t\t\t}\n\t\t\treturn frappe.run_serially(\n\t\t\t\tthis.files.map((file, i) => () => this.upload_file(file, i))\n\t\t\t);\n\t\t},\n\t\tupload_via_file_browser() {\n\t\t\tlet selected_file = this.$refs.file_browser.selected_node;\n\t\t\tif (!selected_file.value) {\n\t\t\t\tfrappe.msgprint(__(\"Click on a file to select it.\"));\n\t\t\t\tthis.close_dialog = true;\n\t\t\t\treturn Promise.reject();\n\t\t\t}\n\t\t\tthis.close_dialog = true;\n\t\t\treturn this.upload_file({\n\t\t\t\tlibrary_file_name: selected_file.value,\n\t\t\t});\n\t\t},\n\t\tupload_via_web_link() {\n\t\t\tlet file_url = this.$refs.web_link.url;\n\t\t\tif (!file_url) {\n\t\t\t\tfrappe.msgprint(__(\"Invalid URL\"));\n\t\t\t\tthis.close_dialog = true;\n\t\t\t\treturn Promise.reject();\n\t\t\t}\n\t\t\tfile_url = decodeURI(file_url);\n\t\t\tthis.close_dialog = true;\n\t\t\treturn this.upload_file({\n\t\t\t\tfile_url,\n\t\t\t});\n\t\t},\n\t\treturn_as_dataurl() {\n\t\t\tlet promises = this.files.map((file) =>\n\t\t\t\tfrappe.dom.file_to_base64(file.file_obj).then((dataurl) => {\n\t\t\t\t\tfile.dataurl = dataurl;\n\t\t\t\t\tthis.on_success && this.on_success(file);\n\t\t\t\t})\n\t\t\t);\n\t\t\tthis.close_dialog = true;\n\t\t\treturn Promise.all(promises);\n\t\t},\n\t\tupload_file(file, i) {\n\t\t\tthis.currently_uploading = i;\n\n\t\t\treturn new Promise((resolve, reject) => {\n\t\t\t\tlet xhr = new XMLHttpRequest();\n\t\t\t\txhr.upload.addEventListener(\"loadstart\", (e) => {\n\t\t\t\t\tfile.uploading = true;\n\t\t\t\t});\n\t\t\t\txhr.upload.addEventListener(\"progress\", (e) => {\n\t\t\t\t\tif (e.lengthComputable) {\n\t\t\t\t\t\tfile.progress = e.loaded;\n\t\t\t\t\t\tfile.total = e.total;\n\t\t\t\t\t}\n\t\t\t\t});\n\t\t\t\txhr.upload.addEventListener(\"load\", (e) => {\n\t\t\t\t\tfile.uploading = false;\n\t\t\t\t\tresolve();\n\t\t\t\t});\n\t\t\t\txhr.addEventListener(\"error\", (e) => {\n\t\t\t\t\tfile.failed = true;\n\t\t\t\t\treject();\n\t\t\t\t});\n\t\t\t\txhr.onreadystatechange = () => {\n\t\t\t\t\tif (xhr.readyState == XMLHttpRequest.DONE) {\n\t\t\t\t\t\tif (xhr.status === 200) {\n\t\t\t\t\t\t\tfile.request_succeeded = true;\n\t\t\t\t\t\t\tlet r = null;\n\t\t\t\t\t\t\tlet file_doc = null;\n\t\t\t\t\t\t\ttry {\n\t\t\t\t\t\t\t\tr = JSON.parse(xhr.responseText);\n\t\t\t\t\t\t\t\tif (r.message.doctype === \"File\") {\n\t\t\t\t\t\t\t\t\tfile_doc = r.message;\n\t\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\t} catch (e) {\n\t\t\t\t\t\t\t\tr = xhr.responseText;\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\tfile.doc = file_doc;\n\n\t\t\t\t\t\t\tif (this.on_success) {\n\t\t\t\t\t\t\t\tthis.on_success(file_doc, r);\n\t\t\t\t\t\t\t}\n\n\t\t\t\t\t\t\tif (\n\t\t\t\t\t\t\t\ti == this.files.length - 1 &&\n\t\t\t\t\t\t\t\tthis.files.every((file) => file.request_succeeded)\n\t\t\t\t\t\t\t) {\n\t\t\t\t\t\t\t\tthis.close_dialog = true;\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t} else if (xhr.status === 403) {\n\t\t\t\t\t\t\tfile.failed = true;\n\t\t\t\t\t\t\tlet response = JSON.parse(xhr.responseText);\n\t\t\t\t\t\t\tfile.error_message = `Not permitted. ${response._error_message || \"\"}`;\n\t\t\t\t\t\t} else if (xhr.status === 413) {\n\t\t\t\t\t\t\tfile.failed = true;\n\t\t\t\t\t\t\tfile.error_message = \"Size exceeds the maximum allowed file size.\";\n\t\t\t\t\t\t} else {\n\t\t\t\t\t\t\tfile.failed = true;\n\t\t\t\t\t\t\tfile.error_message =\n\t\t\t\t\t\t\t\txhr.status === 0\n\t\t\t\t\t\t\t\t\t? \"XMLHttpRequest Error\"\n\t\t\t\t\t\t\t\t\t: `${xhr.status} : ${xhr.statusText}`;\n\n\t\t\t\t\t\t\tlet error = null;\n\t\t\t\t\t\t\ttry {\n\t\t\t\t\t\t\t\terror = JSON.parse(xhr.responseText);\n\t\t\t\t\t\t\t} catch (e) {\n\t\t\t\t\t\t\t\t// pass\n\t\t\t\t\t\t\t}\n\t\t\t\t\t\t\tfrappe.request.cleanup({}, error);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t};\n\t\t\t\txhr.open(\"POST\", \"/api/method/upload_file\", true);\n\t\t\t\txhr.setRequestHeader(\"Accept\", \"application/json\");\n\t\t\t\txhr.setRequestHeader(\"X-Frappe-CSRF-Token\", frappe.csrf_token);\n\n\t\t\t\tlet form_data = new FormData();\n\t\t\t\tif (file.file_obj) {\n\t\t\t\t\tform_data.append(\"file\", file.file_obj, file.name);\n\t\t\t\t}\n\t\t\t\tform_data.append(\"is_private\", +file.private);\n\t\t\t\tform_data.append(\"folder\", this.folder);\n\n\t\t\t\tif (file.file_url) {\n\t\t\t\t\tform_data.append(\"file_url\", file.file_url);\n\t\t\t\t}\n\n\t\t\t\tif (file.file_name) {\n\t\t\t\t\tform_data.append(\"file_name\", file.file_name);\n\t\t\t\t}\n\n\t\t\t\tif (file.library_file_name) {\n\t\t\t\t\tform_data.append(\"library_file_name\", file.library_file_name);\n\t\t\t\t}\n\n\t\t\t\tif (this.doctype && this.docname) {\n\t\t\t\t\tform_data.append(\"doctype\", this.doctype);\n\t\t\t\t\tform_data.append(\"docname\", this.docname);\n\t\t\t\t}\n\n\t\t\t\tif (this.fieldname) {\n\t\t\t\t\tform_data.append(\"fieldname\", this.fieldname);\n\t\t\t\t}\n\n\t\t\t\tif (this.method) {\n\t\t\t\t\tform_data.append(\"method\", this.method);\n\t\t\t\t}\n\n\t\t\t\tif (file.optimize) {\n\t\t\t\t\tform_data.append(\"optimize\", true);\n\t\t\t\t}\n\n\t\t\t\tif (this.attach_doc_image) {\n\t\t\t\t\tform_data.append(\"max_width\", 200);\n\t\t\t\t\tform_data.append(\"max_height\", 200);\n\t\t\t\t}\n\n\t\t\t\txhr.send(form_data);\n\t\t\t});\n\t\t},\n\t\tcapture_image() {\n\t\t\tconst capture = new frappe.ui.Capture({\n\t\t\t\tanimate: false,\n\t\t\t\terror: true,\n\t\t\t});\n\t\t\tcapture.show();\n\t\t\tcapture.submit((data_urls) => {\n\t\t\t\tdata_urls.forEach((data_url) => {\n\t\t\t\t\tlet filename = `capture_${frappe.datetime\n\t\t\t\t\t\t.now_datetime()\n\t\t\t\t\t\t.replaceAll(/[: -]/g, \"_\")}.png`;\n\t\t\t\t\tthis.url_to_file(data_url, filename, \"image/png\").then((file) =>\n\t\t\t\t\t\tthis.add_files([file])\n\t\t\t\t\t);\n\t\t\t\t});\n\t\t\t});\n\t\t},\n\t\tshow_google_drive_picker() {\n\t\t\tthis.close_dialog = true;\n\t\t\tlet google_drive = new GoogleDrivePicker({\n\t\t\t\tpickerCallback: (data) => this.google_drive_callback(data),\n\t\t\t\t...this.google_drive_settings,\n\t\t\t});\n\t\t\tgoogle_drive.loadPicker();\n\t\t},\n\t\tgoogle_drive_callback(data) {\n\t\t\tif (data.action == google.picker.Action.PICKED) {\n\t\t\t\tthis.upload_file({\n\t\t\t\t\tfile_url: data.docs[0].url,\n\t\t\t\t\tfile_name: data.docs[0].name,\n\t\t\t\t});\n\t\t\t} else if (data.action == google.picker.Action.CANCEL) {\n\t\t\t\tcur_frm.attachments.new_attachment();\n\t\t\t}\n\t\t},\n\t\turl_to_file(url, filename, mime_type) {\n\t\t\treturn fetch(url)\n\t\t\t\t.then((res) => res.arrayBuffer())\n\t\t\t\t.then((buffer) => new File([buffer], filename, { type: mime_type }));\n\t\t},\n\t},\n};\n</script>\n<style>\n.file-upload-area {\n\tmin-height: 16rem;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\tborder: 1px dashed var(--dark-border-color);\n\tborder-radius: var(--border-radius);\n\tcursor: pointer;\n\tbackground-color: var(--bg-color);\n}\n\n.btn-file-upload {\n\tbackground-color: transparent;\n\tborder: none;\n\tbox-shadow: none;\n\tfont-size: var(--text-xs);\n}\n</style>\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "frappe/public/js/frappe/file_uploader/FileUploader.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__